import React from 'react'
import Select from '../Select'

export default class SelectProvider extends React.Component {
    state = {provider: '', agent: '', providers: []}

    selectAgent = (agent) => {
        this.setState({agent})
    }

    emailFor = (provider) => {
        const agent = provider && provider.agents && provider.agents.find(a => a.location === this.props.location_id)
        return agent ? agent.value : provider.email
    }

    selectProvider = (provider) => {
        this.setState({provider: provider, agent: this.emailFor(this.findProvider(provider))})
    }

    findProvider = (provider_id) => {
        return this.props.providers.find(p => p.value === provider_id) || {}
    }

    render() {
        return (
            <div>
                <div className={'row mb-4'}>
                    <div className={'col'}>
                        <h6>Alege Furnizorul</h6>
                        <Select carModels={this.props.providers} handleChange={this.selectProvider}/>
                    </div>
                    <div className={'col'}>
                        <h6>Alege Agentia</h6>
                        {this.state.provider &&
                        <Select carModels={this.findProvider(this.state.provider).agents}
                                handleChange={this.selectAgent}/>
                        }
                    </div>
                </div>
                <div className={'row mb-4'}>
                    <div className={'col-md-6'}>
                        <h6>Email Furnizor (alege de mai sus sau il poti scrie)</h6>
                        <input type={'text'} name={'provider[to]'} value={this.state.agent}
                               onChange={(e) => this.setState({agent: e.target.value})} style={{width: '100%'}}
                               className={'form-control'}/>
                    </div>
                </div>
            </div>
        )
    }
}